// app/javascript/compcalc/components/DateCalc.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker as DatePicker } from '@material-ui/pickers';

import moment from "moment";


const styles = theme => ({
  root: {
    // flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  alignCenter: {
    // background: 'green',
    display: 'flex',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  wrapContent: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
});


class DateCalc extends React.PureComponent {

  constructor(props) {
    super(props);
    // console.log('DateCalc.constructor()');

    this.initialState = {
      startDate: '2019-01-01T00:00',
      endDate: '2019-01-01T00:00',

      years: 0,
      months: 0,
      days: 0,

      weeks: 0,
      totalDays: 0,

    };
    this.diff = 0; // End date - start date.
    this.state = { ...this.initialState };
  }

  // --------------------- Selection changed events ---------------------
  onStartDateChanged = (date) => {
    this.diff = 0;
    this.setState({
      startDate: date,
    }, this.calculate);
  }

  onEndDateChanged = (date) => {
    this.diff = 0;
    this.setState({
      endDate: date,
    }, this.calculate);
  }

  onTextChanged = (e) => {
    let component = e.target.name;
    let value = e.target.value;
    // console.log(`onTextChanged ${component} ${value}`);
    const re = component === 'weeks' ? /^-?(\d*)(\.\d*)?$/ : /^-?(\d*)$/; // Allow 2 decimals for weeks.
    if (value === '' || re.test(value)) {
      this.setState({
        [component]: value,
      });
    }
  }

  onTextEntered = (component, value) => {
    this.diff = 1;
    if (component === 'weeks') {
      this.diff = 2;
    }
    else if (component === 'totalDays') {
      this.diff = 3;
    }
    this.calculate();
  }

  // --------------------- Calculations ---------------------
  dateDiff = (start, end) => {
    let years = end.diff(start, 'years');
    let x = new moment(start);
    x.add(years, 'years');

    let months = end.diff(x, 'months');
    x.add(months, 'months');

    let days = end.diff(x, 'days');

    let totalDays = end.diff(start, 'days');
    let weeks = totalDays / 7.0;

    return {
      endDate: end.toDate(),
      years: years,
      months: months,
      days: days,
      weeks: Math.ceil(weeks*100.0) / 100.0,
      totalDays: totalDays,
    };
  }

  calculate = () => {
    let start = moment(this.state.startDate);
    switch (this.diff) {
    case 0: // Start/end date changed. Calculate end date - start date.
      let end = moment(this.state.endDate);
      let newState = this.dateDiff(start, end);
      this.setState(newState);
      break;
    case 1: // Year/month/day changed. Calculate start date + year/month/day.
      end = new moment(start);
      end.add(this.state.years, 'years');
      end.add(this.state.months, 'months');
      end.add(this.state.days, 'days');

      newState = this.dateDiff(start, end);
      this.setState(newState);
      break;
    case 2: // Total weeks changed. Calculate start date + weeks.
      end = new moment(start);
      end.add(this.state.weeks, 'weeks');

      newState = this.dateDiff(start, end);
      this.setState(newState);
      break;
    case 3: // Total days changed. Calculate start date + total days.
      end = new moment(start);
      end.add(this.state.totalDays, 'days');

      newState = this.dateDiff(start, end);
      this.setState(newState);
      break;
    }
  }

  // --------------------- Rendering ---------------------
  render() {
    const { classes } = this.props;

    return (
      <div style={{height: '100%'}}>
      <MuiPickersUtilsProvider utils={ DateFnsUtils }>
      <Grid container spacing={1} className={classes.root}>

        {/* Date of Birth */}
        <Grid item xs={6} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
          <div className="picker">
            <DatePicker
              variant="outlined"
              label="Start Date"
              value={ this.state.startDate }
              onChange={ this.onStartDateChanged }
              format={ 'MM/dd/yyyy' }
            />
          </div>
          </Paper>
        </Grid>

        {/* End Date */}
        <Grid item xs={6} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <div className="picker">
              <DatePicker
                variant="outlined"
                label="End Date"
                value={ this.state.endDate }
                onChange={ this.onEndDateChanged }
                format={ 'MM/dd/yyyy' }
              />
            </div>
          </Paper>
        </Grid>

        <Grid item xs={4}  className={classes.alignCenter}>
          {/* Years */}
          <Paper className={classes.wrapContent}>
            <TextField
              id="years"
              name="years"
              label="Years"
              variant="outlined"
              value={ this.state.years }
              onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
              onChange={ this.onTextChanged }
              onFocus={ (e) => e.target.select() }
              onBlur={ (e) => this.onTextEntered(e.target.name, e.target.value) }
              className={ classes.textField }
              margin="dense"
              InputProps={{
                readOnly: false,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={4}  className={classes.alignCenter}>
          {/* Months */}
          <Paper className={classes.wrapContent}>
            <TextField
              id="months"
              name="months"
              label="Months"
              variant="outlined"
              value={ this.state.months }
              onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
              onChange={ this.onTextChanged }
              onFocus={ (e) => e.target.select() }
              onBlur={ (e) => this.onTextEntered(e.target.name, e.target.value) }
              className={ classes.textField }
              margin="dense"
              InputProps={{
                readOnly: false,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={4}  className={classes.alignCenter}>
          {/* Days */}
          <Paper className={classes.wrapContent}>
            <TextField
              id="days"
              name="days"
              label="Days"
              variant="outlined"
              value={ this.state.days }
              onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
              onChange={ this.onTextChanged }
              onFocus={ (e) => e.target.select() }
              onBlur={ (e) => this.onTextEntered(e.target.name, e.target.value) }
              className={ classes.textField }
              margin="dense"
              InputProps={{
                readOnly: false,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={6}  className={classes.alignCenter}>
          {/* Weeks */}
          <Paper className={classes.wrapContent}>
            <TextField
              id="weeks"
              name="weeks"
              label="Total Weeks"
              variant="outlined"
              value={ this.state.weeks }
              onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
              onChange={ this.onTextChanged }
              onFocus={ (e) => e.target.select() }
              onBlur={ (e) => this.onTextEntered(e.target.name, e.target.value) }
              className={ classes.textField }
              margin="dense"
              InputProps={{
                readOnly: false,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={6}  className={classes.alignCenter}>
          {/* Days */}
          <Paper className={classes.wrapContent}>
            <TextField
              ref="totalDays"
              id="totalDays"
              name="totalDays"
              label="Total Days"
              variant="outlined"
              value={ this.state.totalDays }
              onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
              onChange={ this.onTextChanged }
              onFocus={ (e) => e.target.select() }
              onBlur={ (e) => this.onTextEntered(e.target.name, e.target.value) }
              className={ classes.textField }
              margin="dense"
              InputProps={{
                readOnly: false,
              }}
            />
          </Paper>
        </Grid>

      </Grid>
      </MuiPickersUtilsProvider>
      </div>
    );
  }

};

export default withStyles(styles)(DateCalc);
